import { SharedContent } from './shared-content';
export const InheritanceIneligibleContent = {
  checklistHeading: SharedContent.checklistHeading,
  checklistDesc: SharedContent.checklistDesc,
  buttonLabel: 'Learn more about inheritances',
  contactUs: {
    contactusHeading: 'Please give us a call for next steps',
    contactusDesc:
      'At the moment, we can only complete certain transfers online. We apologize for any inconvenience, especially at a time like this. Please call Vanguard and one of our inheritance specialists can help you.',
  },
  url: 'https://investor.vanguard.com/inherit/',
  contactUsOther: {
    contactusHeading: 'Please call us to continue',
    contactusDesc:
      "Our online transfer process doesn't support all account types at the moment&#151;so if you didn't see the account type you'd like to inherit on our list, you'll have to give us a call. We apologize if this causes any inconvenience, especially at a time like this.",
  },
  contactUsJointAccount: {
    contactusHeading: 'Joint account not found',
    contactusDesc:
      'We were unable to find an eligible joint account for you to inherit.  <br><br> Currently, we only support inheritance transfers for joint accounts with <span class="bold">two owners</span> registered as <span class="bold">Joint tenants with rights of survivorship</span> (JTWROS). If you\'re looking to ' +
      'inherit a joint account with more than two owners, or one that\'s registered as tenants in common or community property (or another registration type), please give us a call at <span class="bold">877-662-7447</span>.' +
      '<br><br>We apologize if this causes any inconvenience, especially at a time like this.',
  },
  additionalInfoHeading: 'Learn more about the inheritance process:',
  IRA: {
    additionalInfoLinkAriaLabel: 'opens a new window / opens in a new tab',
    additionalInfoLinks: [
      {
        label: 'Frequently asked questions',
        link: 'https://investor.vanguard.com/inherit/faq',
      },
      {
        label: 'Understand the different account types',
        link: 'https://investor.vanguard.com/inherit/account-types',
      },
      {
        label: 'Required minimum distributions (RMD)s for IRAs',
        link: 'https://investor.vanguard.com/inherit/ira-rmd',
      },
    ],
  },
  NONRETIREMENT: {
    additionalInfoLinkAriaLabel: 'opens a new window / opens in a new tab',
    additionalInfoLinks: [
      {
        label: 'Frequently asked questions',
        link: 'https://investor.vanguard.com/inherit/faq',
      },
      {
        label: 'Cost basis information',
        link: 'https://investor.vanguard.com/taxes/cost-basis/',
      },
    ],
  },
};
